import { z } from 'zod'

/**
 * Schema for event timing metrics.
 * Use .extend(eventTimingsSchema.shape) to add timings support to event schemas.
 */
export const eventTimingsSchema = z.object({
  timings: z.object({
    tti: z.number().optional(),
    api: z.record(z.string(), z.number()).optional(),
  }).optional(),
})

export type EventTimings = z.infer<typeof eventTimingsSchema>
